import { TamanhoFraldaGeriatricaEnum } from 'graphql/types.generated'

export const tamanhosFralda: TamanhoFraldaGeriatricaEnum[] = [
  TamanhoFraldaGeriatricaEnum.P,
  TamanhoFraldaGeriatricaEnum.M,
  TamanhoFraldaGeriatricaEnum.G,
  TamanhoFraldaGeriatricaEnum.GG,
  TamanhoFraldaGeriatricaEnum.XG,
]
